<template>
    <button v-if="!href" :type="type" class="ui-btn" :class="className">
        <span class="ui-btn__text">
            <slot />
        </span>
    </button>
    <a v-else class="ui-btn" :href="href">
        <span class="ui-btn__text">
            <slot />
        </span>
    </a>
</template>

<script>
export default {
    name: 'UiButton',
    props: {
        type: {
            type: String,
            default: '',
        },
        href: {
            type: String,
            default: '',
        },
        className: {
            type: String,
            default: '',
        }
    },
};
</script>
